import './update-banking-group-rating.scss'

import { notification, Popconfirm } from 'antd'
import axios from 'axios'
import { Formik, FormikHelpers } from 'formik'
import { DatePicker, Form, FormItem, SubmitButton } from 'formik-antd'
import React from 'react'
import { Column, Row } from 'react-display-flex'

import { SelectRating } from '../../../../components/SelectRating'
import { config } from '../../../../config'
import { BankingGroup } from '../models'
import { messages } from './messages'
import { bankingGroupRatingInitialValues, FormBankingGroupRating } from './models'
import { updateBankingGroupRatingValidationSchema } from './validator'

interface UpdateBankingGroupRatingProps {
  group: BankingGroup
  onSuccess: () => void
}

export const UpdateBankingGroupRating = ({ group, onSuccess }: UpdateBankingGroupRatingProps) => {
  const onSubmit = async (data: FormBankingGroupRating, { setSubmitting }: FormikHelpers<FormBankingGroupRating>) => {
    try {
      await axios.post(`/banking-groups/${group?.id}/ratings`, data)

      notification.success({ message: messages.common.success, description: messages.ratings.update.success })

      onSuccess()
    } catch (error) {
      notification.error({ message: messages.common.error, description: messages.ratings.update.error })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Formik
      initialValues={bankingGroupRatingInitialValues}
      validationSchema={updateBankingGroupRatingValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ submitForm }) => (
        <Form name="update-banking-group-rating">
          <Row justifyContentSpaceBetween>
            <dl>
              <dt>Code</dt>
              <dd>{group?.code}</dd>
            </dl>
            <dl>
              <dt>Name</dt>
              <dd>{group?.name}</dd>
            </dl>
            <dl>
              <dt>Issuers</dt>
              <dd>{group?.issuers.length}</dd>
            </dl>
          </Row>
          <FormItem name="maturity" label="Start Date" required>
            <DatePicker
              name="startDate"
              aria-label="startDate"
              placeholder="Start Date"
              format={config.defaultDateFormat}
            />
          </FormItem>
          <FormItem name="shortRating" label="Short Rating" required>
            <SelectRating name="shortRating" />
          </FormItem>
          <FormItem name="longRating" label="Long Rating" required>
            <SelectRating name="longRating" longRatings />
          </FormItem>
          <Column>
            <Popconfirm
              title={`You are about to update the ratings of Banking Group with ${group?.issuers.length} issuer${
                group?.issuers.length > 1 ? 's' : ''
              }. Are you sure?`}
              onConfirm={submitForm}
            >
              <SubmitButton htmlType="submit" type="primary">
                Save Banking Group Rating
              </SubmitButton>
            </Popconfirm>
          </Column>
        </Form>
      )}
    </Formik>
  )
}
